import { createAction } from '@reduxjs/toolkit';
import { PersonalTask } from '../../api/personal-tasks';
import { UpdatePayload } from './slice';

export const fetchPersonalTasks = createAction(
  'personalTasks/fetchPersonalTasks',
);

export const updatePersonalTaskSagaAction = createAction<UpdatePayload>(
  'personalTasks/updatePersonalTaskSagaAction',
);

export const deletePersonalTaskSagaAction = createAction<PersonalTask>(
  'personalTasks/deletePersonalTaskSagaAction',
);

export const createPersonalTaskSagaAction = createAction<Partial<PersonalTask>>(
  'personalTasks/createPersonalTask',
);
